<mat-card class="globalTable" fxFlex fxFill fxLayout="column" fxLayoutAlign="space-between center">
    <app-loader></app-loader>
    <div id="rowStartGloballyInTableComponent" class="filter tablefilter" fxLayout.lt-md="column" fxFill fxLayout="row"
        fxLayoutAlign="space-between center">
        <div class="col width50">
            <div class="example-header">
                <mat-form-field>
                    <input id="tableComponentSearchInput" matInput placeholder="Search" [(ngModel)]="value" 
                    (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
                </mat-form-field>
            </div>
        </div>
        <div class="ttcount" *ngIf="totalCount > 0" >

            <span id="tableComponentTotalCountHeading_1" class="mr-10">
                <ng-container *ngIf="filterText.trimRight().trimLeft().length != 0; else showTotalCount">
                    <strong id="tableComponentTotalCountHeading1"> Total Count :
                        {{filteredList.length}} </strong>
                </ng-container>
            </span>

            <span id="tableComponentTotalCountHeading_2" class="mr-10">
                <ng-template #showTotalCount>
                    <strong id="tableComponentTotalCountHeading2"> Total Count : {{totalCount}}
                    </strong>
                </ng-template>
            </span>

            <span id="tableComponentTotalCountLinkIconArea" *ngIf="filteredList.length > 0">
                <a id="main_LnkExport" color="primary" *ngIf="totalCount > 0" href="javascript:void(0)" class="export"
                    (click)="exportAsXLSX()">
                    <span id="tableComponentTotalCountLinkIconGreen">Export <mat-icon>get_app</mat-icon></span>
                </a>
            </span>

        </div>
    </div>

    <div class="example-container flexWfull">

        <!-- Empty Records -->
        <div class="flexWfull mt-10" *ngIf="paginatorTotalLength==0" id="tableComponentNoRecordsHeadingArea">
            <ng-container>
                <div id="tableComponentNoRecordsHeading" style="text-align: center; padding: 20px 0;">
                    No Records To Display
                </div>
            </ng-container>
        </div>

        <!-- Show Records with pagination and sorting -->
        <div class="flexWfull" id="tableComponentScrollableTableStartsHere">
            <div class="flexWfull" *ngIf="paginatorTotalLength>0">
                <div class="scrollable-table flexWfull" id="tableComponentScrollableMatTableAreaStartsHere">


                    <table mat-table id="tableComponentMatTable" #table [dataSource]="dataSource"
                        class="mat-elevation-z8" matSort (matSortChange)="onSortData($event)">

                        <span id="tableComponentDisplayedColumnLoopStartsHere">
                            <ng-container *ngFor="let column of displayedColumns; let colIndex = index"
                                [matColumnDef]="column">

                                <span
                                    id="tableComponentChecksLengthOfClickableColumnsArea{{showColumnNames[colIndex]}}_{{colIndex}}">
                                    <ng-container *ngIf="updatedClickableColumns.length>0; else showNonClickableColumn">

                                        <span
                                            id="tableComponentChecksIfItIsClickableColumnArea{{showColumnNames[colIndex]}}_{{colIndex}}">
                                            <ng-container
                                                *ngIf="updatedClickableColumns[colIndex].clickable; else showNonClickableColumn">

                                                <span
                                                    id="tableComponentIconHeaderArea{{showColumnNames[colIndex]}}_{{colIndex}}">
                                                    <th mat-header-cell
                                                        id="tableComponentIcon{{showColumnNames[colIndex]}}_{{colIndex}}"
                                                        *matHeaderCellDef> {{showColumnNames[colIndex]}}
                                                    </th>
                                                </span>

                                                <span
                                                    id="tableComponentIconValueArea{{showColumnNames[colIndex]}}_{{colIndex}}">
                                                    <td mat-cell
                                                        id="tableComponentIcon{{showColumnNames[colIndex]}}_{{colIndex}}"
                                                        *matCellDef="let element" style="cursor: pointer">

                                                        <span
                                                            id="tableComponentMatToolTipArea{{showColumnNames[colIndex]}}_{{colIndex}}"
                                                            class="greenIcon"
                                                            [matTooltip]="showColumnNames[colIndex] ? showColumnNames[colIndex] : 'click'"
                                                            (click)="clickColumnEvent(colIndex, element, updatedClickableColumns[colIndex].obj.function)">

                                                            <i id="tableComponentMatToolTip{{showColumnNames[colIndex]}}_{{colIndex}}"
                                                                class="material-icons">
                                                                {{updatedClickableColumns[colIndex].obj.icon}}
                                                            </i>
                                                        </span>

                                                    </td>
                                                </span>

                                            </ng-container>
                                        </span>

                                    </ng-container>
                                </span>

                                <span
                                    id="tableComponentNonClickableAreaBlockArea{{showColumnNames[colIndex]}}_{{colIndex}}">
                                    <ng-template #showNonClickableColumn>

                                        <span
                                            id="tableComponentNonClickableBlockArea{{showColumnNames[colIndex]}}_{{colIndex}}">
                                            <th mat-header-cell (matSortChange)="onSortData($event)"
                                                id="tableComponentNonClickable{{showColumnNames[colIndex]}}_{{colIndex}}"
                                                *matHeaderCellDef mat-sort-header>
                                                {{showColumnNames[colIndex]}}
                                            </th>
                                        </span>

                                        <ng-container *ngIf="showBadge == 0 ; else showBadgeTable">
                                            <span
                                                id="tableComponentNonClickableBlockArea{{showColumnNames[colIndex]}}_{{colIndex}}">
                                                <td mat-cell
                                                    id="tableComponentNonClickable{{showColumnNames[colIndex]}}_{{colIndex}}"
                                                    *matCellDef="let row">
                                                    
                                                    <span
                                                        [ngClass]="row[column] === true ? 'isactive' : row[column] === false ? 'inactive' : ''">
                                                        <span *ngIf="greaterThan(row[column], 25)"
                                                            matTooltipClass="tooltip" matTooltip="{{row[column]}}">
                                                            {{row[column].toString()}}</span>
                                                        <span *ngIf="lesssThan(row[column], 25)"
                                                            >
                                                            {{row[column]  === true ? 'Yes' : row[column]  === false ? 'No': row[column]}}</span>
                                                            
                                                    </span>

                                                    
                                                </td>
                                            </span>
                                        </ng-container>

                                        <!-- <ng-container *ngIf="showBadge == -1">
                                            <span
                                                id="tableComponentNonClickableBlockArea{{showColumnNames[colIndex]}}_{{colIndex}}">
                                                <td mat-cell
                                                    id="tableComponentNonClickable{{showColumnNames[colIndex]}}_{{colIndex}}"
                                                    *matCellDef="let row">
                                                    <span
                                                        [ngClass]="row[column] === true ? 'isActive' : row[column] === false ? 'inactive' : ''">
                                                        <span *ngIf="greaterThan(row[column], 25)"
                                                            matTooltipClass="tooltip" matTooltip="{{row[column]}}">
                                                            {{row[column].toString().substring(0,25)+'...'}}</span>
                                                        <span *ngIf="lesssThan(row[column], 25)"
                                                            >
                                                            {{row[column]  === true ? 'Yes' : row[column]  === false ? 'No': row[column]}}</span>
                                                            
                                                    </span>

                                                    
                                                </td>
                                            </span>
                                        </ng-container> -->

                                        <ng-template #showBadgeTable>
                                            <span *ngIf="showBadge != colIndex + 1"
                                                id="tableComponentNonClickableBlockArea{{showColumnNames[colIndex]}}_{{colIndex}}">
                                                <td mat-cell
                                                    id="tableComponentNonClickable{{showColumnNames[colIndex]}}_{{colIndex}}"
                                                    *matCellDef="let row">
                                                    <span *ngIf="greaterThan(row[column], 25)" matTooltipClass="tooltip"
                                                        matTooltip="{{row[column]}}">
                                                        {{row[column].toString().substring(0,24)+'...'}}</span>
                                                    <span *ngIf="lesssThan(row[column], 25)" matTooltipClass="tooltip"
                                                        matTooltip="{{row[column]}}"> {{row[column]}}</span>
                                                </td>
                                            </span>

                                            <span *ngIf="showBadge == colIndex + 1"
                                                id="tableComponentNonClickableBlockArea{{showColumnNames[colIndex]}}_{{colIndex}}">
                                                <td mat-cell
                                                    id="tableComponentNonClickable{{showColumnNames[colIndex]}}_{{colIndex}}"
                                                    *matCellDef="let row">
                                                    <span
                                                        [ngClass]="row[column] === 'Active' ? 'isactive' : 'inactive'">
                                                        {{row[column]}} </span>
                                                </td>
                                            </span>
                                        </ng-template>

                                    </ng-template>
                                </span>

                            </ng-container>
                        </span>

                        
                        <tr mat-header-row id="tableComponentDisplayedColumnsMatHeader"
                            *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                       
                        <tr mat-row id="tableComponentDisplayedColumnsMatRow"
                            *matRowDef="let row; columns: displayedColumns;">
                        </tr>                       
                    </table>
                </div>

                <span id="tableComponentIndividualMatPaginatorBlockArea">
                    <mat-paginator id="tableComponentIndividualMatPaginator" #paginator [length]="paginatorTotalLength"
                        [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                        itemsPerPageLabel="Records Per Page" showFirstLastButtons="true"
                        (page)="pageEventPropogate($event)">
                    </mat-paginator>
                </span>

            </div>
        </div>
    </div>
</mat-card>